import script from "./ThumbnailImage.vue?vue&type=script&setup=true&lang=js"
export * from "./ThumbnailImage.vue?vue&type=script&setup=true&lang=js"

import "./ThumbnailImage.vue?vue&type=style&index=0&id=247624d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-247624d2"]])

export default __exports__